var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 49,
    viewBox: "0 0 34 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.09 0C12.7554 0 8.59839 1.72191 5.53338 4.78692C2.46837 7.85193 0.74646 12.009 0.74646 16.3436C0.74646 25.3698 17.09 48.18 17.09 48.18C17.09 48.18 33.4336 25.3698 33.4336 16.3436C33.4336 14.1973 33.0108 12.072 32.1895 10.0891C31.3682 8.10626 30.1643 6.30456 28.6467 4.78692C27.129 3.26928 25.3273 2.06542 23.3444 1.24408C21.3615 0.422739 19.2363 0 17.09 0ZM17.09 28.9833C14.5901 28.9833 12.1464 28.242 10.0678 26.8531C7.98917 25.4642 6.36911 23.4902 5.41244 21.1806C4.45577 18.871 4.20546 16.3295 4.69317 13.8777C5.18087 11.4258 6.38469 9.17362 8.15239 7.40593C9.92008 5.63823 12.1723 4.43441 14.6241 3.94671C17.076 3.459 19.6174 3.70931 21.927 4.66598C24.2366 5.62265 26.2107 7.24271 27.5996 9.32131C28.9884 11.3999 29.7297 13.8437 29.7297 16.3436C29.7297 18.0034 29.4028 19.647 28.7676 21.1806C28.1324 22.7141 27.2014 24.1075 26.0277 25.2812C24.8539 26.4549 23.4606 27.3859 21.927 28.0211C20.3935 28.6563 18.7499 28.9833 17.09 28.9833Z",
    fill: "#00BD7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1353 14.7551H23.0523V23.2167H11.1353V14.7551Z",
    fill: "#F0BB73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1353 14.7551H23.0523V15.3574H11.1353V14.7551Z",
    fill: "#EAAE6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6583 9.80914V11.902L22.721 13.5581V9.80914H20.6583Z",
    fill: "#D82B5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7386 14.996H9.44141L17.0975 8.87567L24.7386 14.996Z",
    fill: "#D82B5D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3059 18.0826H18.8818V23.2092H15.3059V18.0826Z",
    fill: "#365470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.e59935be7fec732fc51d23ec0a9dd9af.svg";
export { ForwardRef as ReactComponent };